var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandingWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74155 1.85781L4.58322 3.42448C3.62489 3.78281 2.84155 4.91615 2.84155 5.93281V12.1245C2.84155 13.1078 3.49155 14.3995 4.28322 14.9911L7.86655 17.6661C9.04155 18.5495 10.9749 18.5495 12.1499 17.6661L15.7332 14.9911C16.5249 14.3995 17.1749 13.1078 17.1749 12.1245V5.93281C17.1749 4.90781 16.3916 3.77448 15.4332 3.41615L11.2749 1.85781C10.5666 1.59948 9.43322 1.59948 8.74155 1.85781Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54175 9.89206L8.88341 11.2337L12.4667 7.65039",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandingWhite);
export default __webpack_public_path__ + "static/media/branding-white.9e595095d682aaca983be15e698abe83.svg";
export { ForwardRef as ReactComponent };